module.exports = __webpack_public_path__ + "img/logo.aceb4ff2.svg";